import { useDispatch, useSelector } from "react-redux";
import {
  SettingOutlined,
} from "@ant-design/icons";
import React, { useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { breadCrumbListAction,} from "hooks/actions/etcAction";
import { selectkeysAction } from "hooks/actions/etcAction";
import { openKeysAction } from "hooks/actions/etcAction";

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

const Default = () => {
  const navigate = useNavigate();
  const menuList = useSelector((state) => state.etcReducer.menuList);
  const menuGroupList = useSelector((state) => state.etcReducer.menuGroupList);
  const dispatch = useDispatch();
  const defaultRef = useRef(0); // 첫 화면을 위해서 고육지책으로 만든것. 없애면 좋다.


  
  const items1 = !menuGroupList
    ? null
    : menuGroupList.map((menuGroup, idx) => {
        return getItem(
          menuGroup.menu_group_name,
          "MG-" +
            menuGroup.id +
            "-" +
            ("00" + menuGroup.id).slice(-3) +
            "-" +
            menuGroup.menu_group_name +
            "-" +
            menuGroup.google_otp_use_yn,
          <SettingOutlined />,

          menuList.reduce((acc, menu) => {
            if (menu.MenuGroup_id === menuGroup.id) {
              const group = getItem(
                menu.menu_name,
                "ME-" +
                  menu.Menu_id +
                  "-" +
                  ("00" + menu.id).slice(-3) +
                  "-" +
                  menu.menu_name +
                  "-" +
                  menu.menu_url
              );
              acc.push(group);
            }
            return acc;
          }, [])
        );
      });

 

  useEffect(() => {
    // 첫 화면을 표시해주기 위함
    if (items1 !== null && items1.length !== 0 && defaultRef.current < 2) {
      let defaultPath = "";
      let defaultPathGroup = [];
      for (let i = 0; i < items1[0].children.length; i++) {
        if (items1[0].children[i]) {
          defaultPath = items1[0].children[i].key;
          break;
        }
      }
      defaultPathGroup.push(defaultPath, items1[0].key);

      const path = defaultPath.split("-")[4].split("englemining.link")[1];

      let breadCrumbPath = ["HOME"];

      for (let i = defaultPathGroup.length - 1; i >= 0; i--) {
        breadCrumbPath.push(defaultPathGroup[i].split("-")[3]);
      }
      defaultRef.current++;
      navigate(path);
      dispatch(selectkeysAction(defaultPath))
      dispatch(openKeysAction([items1[0].key]))
      dispatch(breadCrumbListAction(breadCrumbPath));
    }
  }, [menuGroupList]);

  return (
    <div></div>
  );
};
export default Default;
